import React from "react";
import { MarketingLayout } from "../../components/enterprise2/MarketingLayout";
import { TwoCol } from "../../components/enterprise2/TwoCol";

export default function Blog() {
  return (
    <MarketingLayout
      active="blog"
      title="Blog. Crowther."
      description="Writing on sovereignty, deployment, entity resolution, and what it takes to own intelligence in-country."
    >
      <TwoCol
        as="h1"
        id="e2-blog"
        label="Blog"
        title="Notes from the team."
        lede="Writing on sovereignty, deployment, entity resolution, and what it takes to own intelligence in-country."
      >
        <div className="e2-rows" data-testid="e2-blog-empty">
          <div className="e2-row" style={{ gridTemplateColumns: "1fr" }}>
            <div>
              <p className="e2-serif-lead">First essays are on the way.</p>
              <p className="e2-body" style={{ marginTop: 16, maxWidth: "56ch" }}>
                Rather than pad the shelf, we are letting these arrive when they are worth reading. If a specific question about deployment, entity resolution, or sovereignty is on your mind, write to us and we will make sure the answer reaches you when we publish it.
              </p>
            </div>
          </div>
        </div>
      </TwoCol>
    </MarketingLayout>
  );
}
